import script from "./SelectColor.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectColor.vue?vue&type=script&setup=true&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=0b063efa&lang=scss&scoped=true"

import exportComponent from "/Users/tyk/Desktop/work/kangleiot/biz-sharingspace/sharing-space-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b063efa"]])

export default __exports__